import React, { useState, useRef } from 'react'
import { Outlet, useLocation, useMatch, useNavigate, useOutletContext } from 'react-router-dom'
import { ButtonCreate, LeftSide, RefreshIconContainer, RightSide, SectionName, SubHeaderContainer, Tab, TabsDiv } from '../../../components/styles/subheader-style'
import { RefreshCw, Filter } from 'lucide-react'
import { Content } from './style'
import { usePersistedFilters } from '../../../hooks/usePersistedFilters'
import FilterMenu from '../../../components/SubHeaderFilter/FilterMenu'
import AppliedFiltersDisplay from '../../../components/SubHeaderFilter/AppliedFiltersDisplay'
import { Header } from '../../../components/SubHeaderFilter/types'

const TAB_INDEX_NF = 0
const TAB_INDEX_TAX = 1

export const invoiceHeaders: Header[] = [
    { key: 'status', label: 'Situação', type: 'string', selectOptions: [
        { value: 'RASCUNHO', label: 'Rascunho' },
        { value: 'EMITINDO', label: 'Emitindo' },
        { value: 'EMITIDA', label: 'Emitida' },
        { value: 'NEGADA', label: 'Negada' },
        { value: 'CANCELANDO', label: 'Cancelando' },
        { value: 'CANCELADA', label: 'Cancelada' }
    ]},
    { key: 'numeroNF', label: 'Número NF', type: 'string' },
    { key: 'serie', label: 'Série', type: 'string' },
    { key: 'client', label: 'Cliente', type: 'string' },
    { key: 'valorTotalNota', label: 'Valor Total', type: 'number' }
]

interface TypeMainOutlet {
    search: string
}

const TaxModuleLayout: React.FC = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const [refresh, setRefresh] = useState(false)
    const [handleChildSubmit, setHandleChildSubmit] = useState<(() => void) | null>(null);
    const { search } = useOutletContext<TypeMainOutlet>() || { search: '' }
    const [isFilterMenuOpen, setIsFilterMenuOpen] = useState(false)
    const filterButtonRef = useRef<HTMLDivElement | null>(null)

    const isTaxScenario = !!useMatch('/panel/invoice/tax-scenario')
    const isCreatingScenario = !!useMatch('/panel/invoice/tax-scenario/create')
    const isCreatingInvoice = !!useMatch('/panel/invoice/create');
    const isEditingInvoice = !!useMatch('/panel/invoice/edit/:id');
    const isViewingInvoice = !!useMatch('/panel/invoice/view/:id');
    const isInvoiceDetail = isCreatingInvoice || isEditingInvoice || isViewingInvoice;
    
    const handleNewScenario = () => {
        navigate('/panel/invoice/tax-scenario/create')
    }

    const invoiceFiltersState = usePersistedFilters('tax_invoice')

    return (
        <>
            <SubHeaderContainer>
                <LeftSide>
                    <SectionName>Fiscal</SectionName>
                    
                    <TabsDiv>
    {taxTabs.map((tab) => (
        <Tab
            key={tab.index}
            $isFirst={tab.index === 0}
            $isLast={tab.index === taxTabs.length - 1}
            $isActive={
                                location.pathname === tab.path ||
                                (tab.index === TAB_INDEX_NF && isInvoiceDetail) ||
                                (tab.index === TAB_INDEX_TAX && isCreatingScenario)
                            }
            onClick={() => navigate(tab.path)}
        >
            {tab.name}
        </Tab>
    ))}
</TabsDiv>
                </LeftSide>

                <RightSide>
                    {!isCreatingScenario && !isInvoiceDetail && !isTaxScenario && (
                        <div ref={filterButtonRef} style={{ display: 'flex', alignItems: 'center', gap: '8px', position: 'relative' }}>
                            <RefreshIconContainer
                                onClick={() => setIsFilterMenuOpen(true)}
                                title="Filtrar"
                            >
                                <Filter size={20} />
                            </RefreshIconContainer>
                            {isFilterMenuOpen && (
                                <FilterMenu
                                    headers={invoiceHeaders}
                                    filters={invoiceFiltersState.appliedFilters}
                                    onApplyFilter={(f) => {
                                        invoiceFiltersState.handleApplyFilter(f)
                                        setIsFilterMenuOpen(false)
                                    }}
                                    onClose={() => setIsFilterMenuOpen(false)}
                                    anchorRef={filterButtonRef}
                                />
                            )}
                        </div>
                    )}

                    {!isCreatingScenario && (
                        <RefreshIconContainer
                            onClick={() => setRefresh((prev) => !prev)}
                            title='Atualizar'
                        >
                            <RefreshCw size={20} />
                        </RefreshIconContainer>
                    )}

                    {isCreatingScenario ? (
                        <>
                            <ButtonCreate
                                onClick={() => navigate(-1)}
                                style={{ background: '#fff', color: '#0090D3', border: '1px solid #0090D3' }}
                            >
                                Cancelar
                            </ButtonCreate>
                            <ButtonCreate onClick={() => handleChildSubmit && handleChildSubmit()}>
                                Salvar Cenário
                            </ButtonCreate>
                        </>
                    ) : (
                        isTaxScenario && (
                            <ButtonCreate onClick={handleNewScenario}>+ Novo Cenário</ButtonCreate>
                        )
                    )}
                </RightSide>
            </SubHeaderContainer>

            {!isCreatingScenario && !isInvoiceDetail && !isTaxScenario && (
                <AppliedFiltersDisplay
                    filters={invoiceFiltersState.appliedFilters}
                    onRemoveFilter={invoiceFiltersState.handleRemoveFilter}
                    onClearAll={invoiceFiltersState.handleClearAll}
                />
            )}

            <Content>
                <Outlet context={{ setHandleChildSubmit, refresh, search, appliedFilters: invoiceFiltersState.appliedFilters }} />
            </Content>
        </>
    )
}

const taxTabs = [
    { path: '/panel/invoice', name: 'Nota Fiscal', index: TAB_INDEX_NF },
    { path: '/panel/invoice/tax-scenario', name: 'Cenário Fiscal', index: TAB_INDEX_TAX }
]

export default TaxModuleLayout